/**
 * An Application Manifest that gives our tooling the ability to quickly load
 * and use certain parts of the application without fully loading it into memory.
 */
export type Manifest = {
  // Full path of the application on disk
  path: string;
  // Unique, unchanging identifier for this application.
  key: string;
  // Whether the API for this application is considered "public" (e.g., will be exposed to the mobile application and/or to external consumers)
  isPublic: boolean;
  // The GQL schema of this application (without any shared or federated types)
  schema: string | null;
  // Applications that this application depends on.
  dependencies: string[];
  // The path to the application's React component. If this is not null, it is expected to be a valid `path/to/component#exportName` file path. (If no export name is provided, the default export will be used.)
  reactComponent: string | null;
  // Whether this application is an API or an application
  isApiOrApplication?: boolean;
};
